import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var generateStyle = function generateStyle(componentTheme, props, state) {
  return {
    emptyText: {
      display: 'block',
      margin: "".concat(componentTheme.emptyTextMargin, " 0 0 0")
    },
    page: {
      overflow: 'auto',
      flex: '1',
      backgroundColor: componentTheme.pageBackgroundColor
    },
    scoreToggleWrapper: _objectSpread({
      display: 'inline-block',
      transition: 'transform 0.3s'
    }, !state.displayScoreAsPercentage && {
      transform: 'scaleX(-1)'
    })
  };
};
export default generateStyle;